/**
 * Hand the browser a file.
 *
 * The object URL is revoked and the anchor removed in a finally, because a failure between
 * creating and clicking would otherwise leak the blob for the life of the page — and these
 * blobs are whole exports, not thumbnails.
 */
export function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  try {
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
  } finally {
    window.URL.revokeObjectURL(url);
    if (a.parentNode) a.parentNode.removeChild(a);
  }
}

/** `sku-map-2026-09-18.csv` — dated, so a folder of exports stays sortable. */
export function datedFilename(stem, ext = 'csv') {
  return `${stem}-${new Date().toISOString().slice(0, 10)}.${ext}`;
}

export default { saveBlob, datedFilename };
